import { useEffect, useState } from 'react';

/**
 * Il breakpoint della sezione statistiche, letto una volta sola. 768px è il valore già più usato
 * nel CSS del progetto: tenerne uno solo è ciò che permette a tabella e card di essere due forme
 * dello stesso elenco invece di due componenti che si contraddicono.
 */
export const BREAKPOINT_DESKTOP = 768;

const query = `(min-width: ${BREAKPOINT_DESKTOP}px)`;

export default function useDesktop() {
  const [desktop, setDesktop] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setDesktop(e.matches);
    mq.addEventListener('change', onChange);
    setDesktop(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return desktop;
}
